/**
 * Reprise de session et de recherche interrompue — EF-FIC-001, EF-MOD-008.
 *
 * L'application n'ayant plus d'écran d'accueil, la proposition de reprise
 * s'affiche en tête de l'onglet Roadbook, là où l'application s'ouvre.
 */

import type { JSX } from 'preact';
import { ACTIONS, MARKERS } from '../labels';
import {
  discardInterruptedSearch,
  persistence,
  readOnly,
  reloadSession,
  sessionInfo,
  startSearch,
  takeOverSession,
} from '../state';
import { persistenceMessage } from '../../platform/persistence';

export function SessionNotice(): JSX.Element | null {
  const session = sessionInfo.value;
  const locked = readOnly.value;
  const persisted = persistence.value;

  if (session === null && !locked && persisted === 'accordée') return null;

  return (
    <>
      {locked ? (
        <div class="notice">
          <p>{MARKERS.readOnly}</p>
          <button
            type="button"
            onClick={() => {
              void takeOverSession();
            }}
          >
            {ACTIONS.takeOver}
          </button>
        </div>
      ) : null}

      {persisted !== 'accordée' ? (
        <div class="notice">
          <p>{persistenceMessage(persisted)}</p>
        </div>
      ) : null}

      {session !== null ? (
        <div class="notice">
          <p>
            Session précédente : « {session.title} », enregistrée le{' '}
            {new Date(session.savedAt).toLocaleString('fr-FR')}.
          </p>
          <div class="actions">
            <button
              type="button"
              class="primary"
              onClick={() => {
                void reloadSession();
              }}
            >
              {ACTIONS.resumeSession}
            </button>
          </div>

          {session.hasInterruptedSearch ? (
            <>
              <p>
                Une recherche a été interrompue. Vous pouvez la reprendre, la conserver telle quelle ou
                l’abandonner.
              </p>
              <div class="actions">
                <button
                  type="button"
                  onClick={() => {
                    void reloadSession().then(() => startSearch(undefined, true));
                  }}
                >
                  {ACTIONS.resumeSearch}
                </button>
                <button
                  type="button"
                  onClick={() => {
                    void reloadSession();
                  }}
                >
                  Conserver le résultat partiel
                </button>
                <button
                  type="button"
                  onClick={() => {
                    void discardInterruptedSearch();
                  }}
                >
                  Abandonner
                </button>
              </div>
            </>
          ) : null}
        </div>
      ) : null}
    </>
  );
}
